import React, { useState, useEffect, useRef } from "react";
import "./LoadingPage.css";
import walkingGif from "./walking.gif";

const phrases = [
  "Finding the best deals near you…",
  "Checking which restaurants are in your building’s perks program…",
  "Loading offers you can use today…",
  "Saving you a little money around the neighborhood…",
  "Pulling in fresh deals from nearby restaurants and bars…",
  "Checking your building’s perks and discounts…",
  "Getting your loyalty perks ready…",
  "Matching you with spots within walking distance…",
  "Warming up your neighborhood deals…",
  "Loading places where your Block Club perks work…",
  "Almost there — your local offers are on the way…",
  "Confirming which venues are part of your program…",
  "Refreshing your deals so you see what’s current…",
  "Finding locations that honor your Block Club perks…",
  "Connecting your email to your building’s loyalty program…",
  "Loading your favorite places around the block…",
  "Checking for new offers added by your local restaurants…",
  "Setting up your account so you can redeem in seconds…",
  "Pulling in member-only discounts for your area…",
  "Making sure everything is ready before you redeem…",
  "Preparing your personalized neighborhood deals…",
  "Sorting offers so the closest spots show first…",
  "Verifying your access through your building’s program…",
  "Loading restaurants, bars, and cafes that want to treat you…",
  "Tidying up your deals so they’re easy to browse…",
  "Almost done — your loyalty perks are just about ready…",
  "Syncing with your building’s perks program…",
  "Finding places where you can show a code and save…",
  "Checking in with our partners so your perks are up to date…",
  "Loading offers that help you explore your neighborhood…",
];

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

function LoadingPage() {
  const shuffledRef = useRef(shuffleArray(phrases));
  const indexRef = useRef(0);
  const [currentPhrase, setCurrentPhrase] = useState(shuffledRef.current[0]);
  const [fadeKey, setFadeKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current += 1;

      if (indexRef.current >= shuffledRef.current.length) {
        shuffledRef.current = shuffleArray(phrases);
        indexRef.current = 0;
      }

      setCurrentPhrase(shuffledRef.current[indexRef.current]);
      setFadeKey(prev => prev + 1); // Trigger re-animation
    }, 4000); // Rotate every 4 seconds (faster for better UX)

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-page">
      <div className="loader-container">
        <img src={walkingGif} alt="Loading..." className="loading-gif" />
        <p key={fadeKey} className="loading-text-animated">{currentPhrase}</p>
      </div>
    </div>
  );
}

export default LoadingPage;
